module.exports = __webpack_public_path__ + "img/sell.d24cf89c.png";